module.exports = __webpack_public_path__ + "static/img/psi-logo-full.307e7d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/psi-logo-full.svg
// module id = cBx1
// module chunks = 1